import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Status } from "../../models/interfaces/status.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-committee_add",
  templateUrl: "committee_add.html",
})
export class CommitteeAddPage {
  private loading: any;
  private status$;
  private committeeForm: FormGroup;
  private MaxYear = new Date(new Date());
  private MM = parseInt(this.MaxYear.toISOString().substring(0, 4)) + 2;
  private styleName: string ="";
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("CommitteeAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.committeeForm = this.formBuilder.group({
      "co_active_flg": [true, Validators.required],
      "co_email": ["", [Validators.required, ValidationserviceProvider.emailValidator]],
      "co_fromdate": ["", Validators.required],
      "co_name": ["", [Validators.required]],
      "co_todate": ["", Validators.required],
    });
  }
  private ionViewWillEnter() {
    console.log("CommitteeAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("CommitteeAddPage onInitPage");
    this.status$ = this.db.dbCol({
      "action": "select", "mapObject": "status",
      "sqlExtended": " order by st_order",
    });
  }

  private goback() {
    console.log("CommitteeAddPage goback");
    this.navCtrl.pop();
  }

  private addCommittee(value: any) {
    console.log("CommitteeAddPage addCommittee");
    let oldcoid = this.navParams.data.committee.co_id;

    const formValues: any = {
      "co_active_flg": value.co_active_flg,
      "co_email": value.co_email,
      "co_fromdate": value.co_fromdate,
      "cp_id": this.navParams.data.committee.cp_id,
      "co_name": value.co_name,
      "co_todate": value.co_todate,
    };

    if (this.committeeForm.dirty && this.committeeForm.valid) {
      // 1. add new committee
      // 2. get all admins via the select statements
      // 3. add all mb_ids who were admins as admins in the new committee
      // 4. add the admin role to the mb_id
      this.db.dbCol({ "action": "insert", "mapObject": "committee", ...formValues })
        .subscribe((ret) => {
          // will insert the new committee as per form values
          let newcoid = ret.id;
          this.db.dbCol({
            "action": "select", "mapObject": "committee_member_role",
            "sqlExtended": "where role.ro_id=1",
          }).subscribe((lines) => {
            // carry forward the admins of the previous committe, so the new committee can be edited
            lines.forEach((admins) => {
              this.db.dbCol({ "action": "insert", "mapObject": "committee_member", "co_id": newcoid, "mb_id": (admins as any).mb_id })
                .subscribe((ret2) => {
                  // add the member to the role
                  this.db.dbCol({ "action": "insert", "mapObject": "committee_member_role", "cm_id": ret2.id, "ro_id": (admins as any).ro_id })
                    .subscribe((ret3) => {

                      // deactivate old committee
                      //  this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "update committee set co_active_flg=0 where co_id=" + oldcoid })
                      //    .subscribe((ret4) => {
                      //      this.navCtrl.pop();
                      //    });
                    });
                });
            });
            this.navCtrl.pop();
          });
        });


    }
  }

  private ngOnDestroy() {
    console.log("CommitteeAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/committee/committee_add.ts